"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeTokenConstant = exports.uint256MaxValue = void 0;
exports.uint256MaxValue = "115792089237316195423570985008687907853269984665640564039457584007913129639935";
exports.nativeTokenConstant = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE";
//# sourceMappingURL=index.js.map